export var FilterCombinations;
(function (FilterCombinations) {
    FilterCombinations["AREA"] = "area";
    FilterCombinations["AREA_ATTENDANCE"] = "areaAttendance";
    FilterCombinations["AREA_DISCIPLINE"] = "areaDiscipline";
    FilterCombinations["COUNTRY"] = "country";
    FilterCombinations["DISCIPLINE_AREA"] = "disciplineArea";
    FilterCombinations["DISCIPLINE_ATTENDANCE"] = "disciplineAttendance";
    FilterCombinations["DISCIPLINE_COUNTRY"] = "disciplineCountry";
    FilterCombinations["DISCIPLINE"] = "discipline";
    FilterCombinations["UNFILTERED"] = "unfiltered";
    FilterCombinations["UNIVERSITY_COUNTRY"] = "universityCountry";
    FilterCombinations["ATTENDANCE_DISCIPLINE"] = "attendancedDiscipline";
    FilterCombinations["CONTINENT_ATTENDANCE"] = "continentAttendance";
    FilterCombinations["COUNTRY_ATTENDANCE"] = "countryAttendance";
    FilterCombinations["ATTENDANCE"] = "attendance";
    FilterCombinations["CONTINENT"] = "continent";
})(FilterCombinations || (FilterCombinations = {}));
